export default "__VITE_ASSET__gt0kx2G4__"